module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh-break",
    attrs: {
      "id": "char"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Major Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "lh-nosp"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("United States")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Josh MacArthur, scientist")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Mara Duncan, CIA officer")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Peter Lucas, CIA chief of station, Bangkok/Southeast Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Major Zeus Murphy, former SF captain, adviser to Vietnam People’s Army")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lieutenant Ric Kerfer, SEAL Team platoon commander")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("President George Chester Greene")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("CIA Director Peter Frost")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("National Security Adviser Walter Jackson")])]), _vm._v(" "), _c('p', {
    staticClass: "lh"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("China")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Lieutenant Jing Yo, commander, First Commando Detachment")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Colonel Li Sun, Commando Regiment commander, executive officer Task Force #1")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Premier Cho Lai")])]), _vm._v(" "), _c('p', {
    staticClass: "lh"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Vietnam")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Premier Lein Thap")])]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("General Minh Trung, head of the Vietnam People’s Army")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52074bc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/characters.vue
// module id = 71
// module chunks = 0